import React, { useEffect, useRef, useState } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import configureStore from './Redux/Store/store';
import SplashScreen from 'react-native-splash-screen';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import i18nextInit, { updateAdditionalTranslationResources } from './translations';
import 'intl-pluralrules';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { NavigationContainer, useNavigation, useNavigationContainerRef } from '@react-navigation/native';
import { routes } from './navigation/StackNavigator/routes';
import { setFCMToken } from './Redux/Reducers/appConfigReducer';
import ErrorBoundary from './Apps/errorBoundary/ErrorBoundary';
import { Linking, Platform, Text } from 'react-native';
import { RootApp } from './RootApp.js';
import NotificationListener from './NotificationListener';
import { setInitialTabId, setRedirectInfo } from './Redux/Reducers/deeplinkReducer.js';
import { isWeb, parseEventDataFromUrl } from './utils/Helper.js';

import { CRASHLYTICSCOLLECTION } from './config/Constant';

let crashlytics;
if (Platform.OS !== 'web') {
  const moduleName = '@react-native-firebase/crashlytics';
  import(/* webpackIgnore: true */ moduleName)
    .then(module => {
      crashlytics = module.default;
    })
    .catch(() => {});
}


const { store, persistor } = configureStore();

const App = () => {


  const handleCrashlytics = async () => {
    if(crashlytics().isCrashlyticsCollectionEnabled != CRASHLYTICSCOLLECTION) {
      await crashlytics().setCrashlyticsCollectionEnabled(CRASHLYTICSCOLLECTION)
          .then(() => {
            console.log("Crashlytics data collection is enabled");
          })
          .catch((error) => console.error("Error enabling Crashlytics data collection:", error));
    }

    crashlytics().didCrashOnPreviousExecution(function(didCrash){
        console.log(`Did crash on previous execution: ${didCrash ? "Yes" : "No"}`);
    }, function(error){
        console.error(`Error getting Crashlytics did crash on previous execution: ${error}`);
    });
  }



  useEffect(() => {

    if (process.env.NODE_ENV === 'production') {
      console.log = () => {};
      console.error = () => {};
      console.warn = () => {};
      console.debug = () => {};
      console.info = () => {};
  }
  
    i18nextInit();
    if(crashlytics) handleCrashlytics();

    setTimeout(() => {
      SplashScreen && SplashScreen.hide();
    }, 1000);


    if(isWeb()){
      const url = window.location.href;
      if (url) handleDeepLink(url);      
    } else {
      Linking.getInitialURL().then((url) => {
        if (url) handleDeepLink(url);
      });
      
      const listener = Linking.addEventListener('url', ({ url }) => {      
          handleDeepLink(url);
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const handleDeepLink = (url) => {
    console.log('Deep link received:', url);
    
    const eventData = parseEventDataFromUrl(url);

    console.log(eventData);
    if (eventData) {
        store.dispatch(setRedirectInfo(eventData));
    }
  }


  const linking = {
    config: {
      path: (process.env.REACT_APP_BASENAME || ''),
      screens: routes.reduce((acc, route) => {
        acc[route.name] = route.name?.toLowerCase();
        return acc;
      }, {}),
    },
  };

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <I18nextProvider i18n={i18next}>
          <ErrorBoundary>
            <NavigationContainer 
              linking={linking}
              fallback={<Text>Loading...</Text>} 
              documentTitle={{
                formatter: (options, route) => `${process.env.REACT_APP_TITLE}`,
              }} 
            >
              <NotificationListener />
              <RootApp />
            </NavigationContainer>
          </ErrorBoundary>
        </I18nextProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
